import Shop from '../shop';

export default class LemonadeStand extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Lemonade stand',
            id:                   'LemonadeStand',
            coolDown:             1,
            faClass:              'fa-lemon-o',
            individualCostFactor: 1.07,
            baseEarnings:         1.0,
            baseCosts:            4.0,
            grade:                1
        });
    }
}
